import api from '@pray/shared/utils/api';
import type { ListResponse } from '@pray/shared/utils/api/types/response';

import type { UserOrganizationResponse } from './types';

type GetUserOrganizationsParams = {
  userId: string;
  includeDestroyed?: boolean;
};

export async function getUserOrganizations({ userId, includeDestroyed = false }: GetUserOrganizationsParams) {
  const url = `/web/studio/users/${userId}/organizations`;

  const queryParams: Record<string, boolean> = {};
  if (includeDestroyed) {
    queryParams.include_destroyed = includeDestroyed;
  }

  const response = await api.executeGetRequest<ListResponse<UserOrganizationResponse>>(url, queryParams);

  return response.data;
}
